import styled from "styled-components";

export const StyledImageContainer = styled.div`
  width: 300px;
  height: 350px;
  position: relative;
  margin-top: 30px;
  svg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;

export const StyledMainContainer = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  grid-row-gap: 10px;
`;

export const StyledTitle = styled.div`
  font-size: 24px;
  line-height: 30px;
  color: #0068ff;
`;

export const StyledDescription = styled.div`
  text-align: center;
  font-size: 12px;
  line-height: 24px;
  color: #37373a;
  max-width: 65%;
`;
